<script setup lang="ts">
import { ref } from "vue";
import { useTranslation } from "i18next-vue";

import type { DriverSetupConfirmationPage } from "@/types/integrationInstance";

import translatedProperty from "@/mixins/translatedProperty";
import { useComponentErrorCapture } from "@/mixins/error";

import VueMarkdown from 'vue-markdown-render'

const { t } = useTranslation();
useComponentErrorCapture();

const props = defineProps({
  confirmation: {
    type: Object,
    required: true,
  },
  className: {
    type: [String, Array, Object],
    default: "",
  },
});

const confirmation = ref<DriverSetupConfirmationPage>(
  props.confirmation as DriverSetupConfirmationPage
);
</script>
<template>
  <div :class="className" v-overflow-indicator>
    <h4 v-if="confirmation.title">
      {{ translatedProperty(confirmation.title) }}
    </h4>
    <div class="markdown-wrapper" v-markdown-tools>
      <vue-markdown
        v-if="confirmation.message1"
        :source="translatedProperty(confirmation.message1)"
        class="vue-markdown"
      />
    </div>

    <img
      v-if="confirmation.image"
      role="presentation"
      alt=""
      :src="'data:image;base64, ' + confirmation.image"
    />

    <div class="markdown-wrapper" v-markdown-tools>
      <vue-markdown
        v-if="confirmation.message2"
        :source="translatedProperty(confirmation.message2)"
        class="vue-markdown"
      />
    </div>
  </div>
</template>
